import React, { ReactNode } from 'react'
import { PostHogProvider, usePostHog } from 'posthog-js/react'
import {
  ProductAnalyticsContext,
  ProductAnalyticsContextValue,
} from 'features/product-analytics/ProductAnalyticsProvider'
import { ProductEvents } from 'features/product-analytics/Events.types'

const API_KEY = process.env.CT_POSTHOG_API_KEY || ''
const PROXY_URL = process.env.CT_POSTHOG_PROXY_URL || ''

export default function PostHogAnalyticsProvider({ children }: { children: ReactNode }) {
  return (
    <PostHogProvider apiKey={API_KEY} options={{ api_host: PROXY_URL, ui_host: 'us.i.posthog.com' }}>
      <ProviderImpl>{children}</ProviderImpl>
    </PostHogProvider>
  )
}

function ProviderImpl({ children }: { children: ReactNode }) {
  const client = usePostHog()

  function identify(
    id: Parameters<ProductAnalyticsContextValue['identify']>[0],
    traits: Parameters<ProductAnalyticsContextValue['identify']>[1]
  ) {
    client?.identify(id, traits)
  }

  function trackEvent(event: ProductEvents) {
    client?.capture(event.type, event.payload)
  }

  function reset() {
    client?.reset()
  }

  return (
    <ProductAnalyticsContext.Provider
      value={{
        identify,
        trackEvent,
        reset,
      }}
    >
      {children}
    </ProductAnalyticsContext.Provider>
  )
}
